import { render, staticRenderFns } from "./InstitutionsList.vue?vue&type=template&id=80f6c3b6&"
import script from "./InstitutionsList.vue?vue&type=script&lang=js&"
export * from "./InstitutionsList.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports